import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildTicketActionLogsRequest = ({
  projectId,
  ticketId,
}: {
  projectId: string;
  ticketId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/action_logs`,
});
